import { render } from "./TenderEntityH5.vue?vue&type=template&id=e8aec436&scoped=true"
import script from "./TenderEntityH5.vue?vue&type=script&lang=js"
export * from "./TenderEntityH5.vue?vue&type=script&lang=js"

import "./TenderEntityH5.vue?vue&type=style&index=0&id=e8aec436&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8aec436"]])

export default __exports__